// DeliveryOptions.tsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, firestore } from "../../../../firebaseConfig";
import { collection, doc, getDoc } from "firebase/firestore";
import * as S from "./styles";
import AddressForm from "../../../../components/user/Address/Address";
import DeliveryOptionsInfo from "../../../../components/Delivery/DeliveryOptions";

const DeliveryOptions = () => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("storeCollect");
  const [userDetails, setUserDetails] = useState({
    firstName: "",
    address: {
      streetAddress: "",
      city: "",
      postalAddress: "",
      country: "",
    },
    phoneNumber: "",
  });
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [showDeliveryOptions, setShowDeliveryOptions] = useState(true);
  const [isLoading, setIsLoading] = useState(true); // Added loading state

  const pricing = {
    storeCollect: "$0",
    cargoDropOff: "$10",
    homeDelivery: "$20",
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (auth.currentUser) {
        const userDoc = doc(collection(firestore, "users"), auth.currentUser.uid);
        const docSnap = await getDoc(userDoc);

        if (docSnap.exists()) {
          const userData = docSnap.data();
          setUserDetails({
            firstName: userData.firstName || "",
            address: userData.address || {
              streetAddress: "",
              city: "",
              postalAddress: "",
              country: "",
            },
            phoneNumber: userData.phoneNumber || "",
          });
        }
      }
      setIsLoading(false); // Mark loading as complete
    };

    fetchUserDetails();
  }, []);

  const handleNext = () => {
    if (selectedOption === "storeCollect") {
      navigate("/store-search");
    } else if (selectedOption === "cargoDropOff") {
      navigate("/cargo-location");
    } else if (selectedOption === "homeDelivery") {
      if (!userDetails.address.streetAddress) {
        // Address not available, prompt user to set their home address
        setShowAddressForm(true);
        setShowDeliveryOptions(false);
      } else {
        // Address is available, proceed to address input
        navigate("/address-input");
      }
    }
  };

  return (
    <div>
      <S.Container>
        <S.Content>
          <S.Heading>Select Delivery Option</S.Heading>
          {showDeliveryOptions && (
            <DeliveryOptionsInfo
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              pricing={pricing}
              setAddress={(value) => setUserDetails({ ...userDetails, address: { ...userDetails.address, streetAddress: value } })}
            />
          )}
          {selectedOption === "homeDelivery" && (
            <div>
              {isLoading ? (
                <p>Loading...</p>
              ) : auth.currentUser ? (
                userDetails.address.streetAddress ? (
                  <div>
                    <p>User Name: {userDetails.firstName}</p>
                    <p>
                      Street Address: {userDetails.address.streetAddress}, {userDetails.address.city}, {userDetails.address.postalAddress}, {userDetails.address.country}
                    </p>
                    <p>Phone Number: {userDetails.phoneNumber}</p>
                  </div>
                ) : (
                  // Address not available, prompt user to set their home address
                  <button
                    onClick={() => {
                      setShowAddressForm(true);
                      setShowDeliveryOptions(false);
                    }}
                  >
                    Set Home Address
                  </button>
                )
              ) : (
                // User not signed in, prompt user to sign in or create an account
                <p>Please sign in or create an account to set your home address.</p>
              )}
            </div>
          )}
          <S.Button onClick={handleNext}>Next</S.Button>
        </S.Content>
      </S.Container>

      {showAddressForm && (
        <AddressForm
          setAddress={(value) => setUserDetails({ ...userDetails, address: { ...userDetails.address, streetAddress: value } })}
          setShowAddressForm={setShowAddressForm}
          setShowDeliveryOptions={setShowDeliveryOptions}
        />
      )}
    </div>
  );
};

export default DeliveryOptions;
